import { render, staticRenderFns } from "./BaseTextareaOutlined.vue?vue&type=template&id=259c555a&"
import script from "./BaseTextareaOutlined.vue?vue&type=script&lang=js&"
export * from "./BaseTextareaOutlined.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextareaOutlined.vue?vue&type=style&index=0&id=259c555a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports